// extracted by mini-css-extract-plugin
module.exports = {"overlayArea":"overlayArea-mfX4k","scroll":"scroll-Y141l","accountPanelV2":"accountPanelV2-yIEQR","links":"links-mQhvm"};